<template>
  <header>
    <div class="wrap row">
      <div class="logo">
        <router-link :to="{name: 'Home'}">
          <img src="/static/images/logo/logo-color.svg" alt="">
        </router-link>
      </div>

      <!-- Toogle -->
      <elements-hamburger />

      <!-- Mobile navigation -->
      <div class="mobile-navigation">
        <div>
          <small>Privat</small>
          <a href="https://www.sparnord.dk/privat/raadgivning.aspx">Rådgivning</a>
          <a href="https://www.sparnord.dk/privat/produkter.aspx">Produkter</a>
          <a href="https://www.sparnord.dk/privat/kundeservice.aspx">Kundeservice</a>
        </div>
        <div>
          <small>Erhverv</small>
          <a href="https://www.sparnord.dk/erhverv/raadgivning.aspx">Rådgivning</a>
          <a href="https://www.sparnord.dk/erhverv/produkter.aspx">Produkter</a>
          <a href="https://www.sparnord.dk/erhverv/kundeservice.aspx">Kundeservice</a>
        </div>
        <div>
          <small>Om Spar Nord</small>
          <a href="https://www.sparnord.com/">Om</a>
          <a href="https://www.sparnord.dk/om-spar-nord/kontakt/find-sted-eller-person.aspx">Kontakt</a>
          <a href="https://www.sparnord.com/">Investor</a>
          <a href="https://www.sparnord.com/presse/">Presse</a>
        </div>
        <div>
          <small>sparnord.com</small>
          <a href="https://www.sparnord.com/en/">About</a>
          <a href="https://www.sparnord.com/en/investor-relations/">Invstor Relations</a>
          <a href="https://www.sparnord.com/en/investor-relations/organization/">Organization & Management</a>
          <a href="https://www.sparnord.com/en/investor-relations/#kontakt">Contact</a>
        </div>
      </div>

      <!-- Sub navigation -->
      <div class="navigation">
        <div class="sub-navigation">
          <div class="sub">
            <a href="https://www.sparnord.dk/privat" class="sub-item selected">Privat</a>
            <a href="https://erhverv.sparnord.dk/" class="sub-item">Erhverv</a>
            <a href="http://privatebanking.sparnord.dk/" class="sub-item">Private Banking</a>
            <a href="http://investering.sparnord.dk/" class="sub-item">Investering</a>
            <a href="https://www.sparnord.com/" class="sub-item">Om Spar Nord</a>
            <span class="seperator"></span>
          </div>
          <div class="service">
            <a href="https://www.sparnord.dk/privat/kundeservice" class="sub-item">Kundeservice</a>
            <!-- <span class="sep"></span> -->
            <a href="https://www.sparnord.dk/om-spar-nord/kontakt/find-sted-eller-person.aspx" class="sub-item">Kontakt</a>
          </div>
        </div>

        <!-- Main navigation -->
        <div class="main-navigation">
          <div class="nav-search">
            <!-- <div class="main-navigation-wrap">
              <div class="breadcrumb">
                /Nyheder
              </div>
              <div class="main-nav">

              </div>
            </div> -->

            <!-- <form class="search" @submit.prevent="doSearch">
              <input type="search" placeholder="Søg" :value="query" @input="onInput">
              <icon class="icon-search" name="search"></icon>
            </form> -->
          </div>

          <div class="nav-second">
            <div class="netbank">
              <a href="https://netbank.sparnord.dk/signon/servlet/Signon?_Or=_2gMOiOzXTJDIB26J6dmT0UDehmvhna-EKg9Kw97axIf77GoDtaj4vXN8i0WGWuVkEbF-kr5Ci8f8ipK-aVOvsQt3-YCni7U_&_Wp=No">
                Netbank
                <icon name="lock"></icon>
              </a>
            </div>
          </div>
        </div>

      </div>

    </div>
  </header>
</template>

<script>
import SearchMixin from '@/mixins/search'
import ElementsHamburger from '@elements/hamburger'
import Icon from 'vue-awesome/components/Icon'

import 'vue-awesome/icons/lock'
import 'vue-awesome/icons/search'

export default {
  components: { ElementsHamburger, Icon },
  mixins: [SearchMixin]
}
</script>

<style lang="scss" scoped>
/* Import from Spar Nord Assets */
@import '~@styles/global/index';
@import '~@styles/colors/variables';
@import '~@styles/mq/variables';
@import '~@styles/mixins/font-size';
@import '~@animations/easings/variables';
@import '~@animations/durations/variables';

header {
  height: 140px;
  padding: 25px 0 0;
  background: white;

  position: relative;
  z-index: 10;

  @at-root .internet-explorer #{&} {
    flex: 0 0 115px;
  }

  background-color: $color-white;
  // background: linear-gradient($color-white, #F5F5F5);
  border-bottom: 1px solid $color-grey;

  @media #{$below-breakpoint-768} {
    height: 70px;
    padding: 15px 0;
    background: $color-white;

    @at-root .internet-explorer #{&} {
      flex: 0 0 40px;
    }
  }
}

.row {
  display: flex;
  flex-wrap: wrap;

  align-items: flex-end;

  height: 100%;
}

.logo {
  flex: 0 1 140px;

  @media #{$below-breakpoint-768} {
    flex: 0 1 120px;
  }

  @media (max-width: 992px) and (min-width: 768px) {
    flex: 0 1 100px;
  }
}

.navigation {
  display: flex;
  flex-direction: column;
  flex: 1 1 1%;
}

.logo {
  margin-top: auto;

  @media #{$above-breakpoint-768} {
    margin-bottom: $global-padding;

    @at-root .internet-explorer #{&} {
      margin-bottom: 18px;
    }
  }

  a {
    display: block;
  }

  img {
    width: 100%;
    vertical-align: bottom;
  }
}

.navigation {
  margin-left: 8%;
  height: 100%;

  @media #{$below-breakpoint-768} {
    display: none;
  }
}

// Breadcrumb
.breadcrumb {
  font-size: 11px;
  color: #aabacb;

  text-transform: uppercase;
  font-weight: 700;

  margin-bottom: 8px;
}

// Main navigation
.main-navigation {
  margin-top: auto;

  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;

  position: relative;
}

.main-navigation-wrap {
  flex: 1 1 auto;
  height: $global-padding * 3;
  margin-right: $global-padding * 2;
}

.nav-search {
  display: flex;
  margin-right: auto;
  height: $global-padding * 3;
}

.main-navigation-wrap + .search {
  margin-left: 15px;

  &:before {
    content: "";

    height: 25px;
    width: 1px;
    background: $color-grey-x;

    display: block;
    position: absolute;
    left: -15px;
    top: 5px;
  }
}

.search {
  transform: translateY(10px);

  &input:hover {
    .icon-search {
      fill: $color-black;
      transition: all $duration-normal $easeing-OutExpo;
    }

    input {
      border-color: $color-black;
      transition: all $duration-normal $easeing-OutExpo;
    }
  }

  .icon-search {
    position: absolute;
    fill: $color-grey-xx;

    top: 18px;
    left: 10px;

    height: 14px;
    width: 14px;

    transform: translateY(-50%);

    transition: all $duration-normal $easeing-OutExpo;

    @at-root .internet-explorer #{&} {
      top: 0px;
      transform: translateY(12px);
    }
  }

  input:focus ~ .icon-search {
    fill: $color-red;
  }

  input {
    -webkit-appearance: none;

    line-height: 1;

    border: 1px solid $color-grey-x;
    background-color: $color-white;
    padding: 7px 10px;

    height: 37px;

    font-weight: 900;

    text-indent: 25px;

    @include font-size(14px, 16px);

    transition: all $duration-normal $easeing-OutExpo;

    @at-root .internet-explorer #{&} {
      padding: 0px 10px 0 15px;
      line-height: normal;
    }

    &:hover {
      border-color: $color-grey-x;
    }

    &:focus {
      border-color: $color-red;

      &::placeholder {
        color: $color-grey-xx;
      }
    }

    &::placeholder {
      color: $color-black-x;
      text-transform: uppercase;

      transform: translateY(2px);

      transition: all $duration-normal $easeing-OutExpo;
    }
  }
}

.microsoft-edge input {
  text-indent: 0;
  padding: 0 0 0 30px;
}

.netbank {
  margin-left: auto;

  align-self: flex-end;

  flex: 1 1 auto;

  margin-bottom: 12px;

  a {
    font-weight: 700;
    padding: 10px 12px;
    background-color: $color-red;
    color: $color-white;

    font-size: 14px;

    display: flex;
    align-items: center;

    &:hover {
      background-color: $color-red-x;
    }
  }

  .fa-icon {
    margin-left: 8px;
  }
}

.main-item {
  font-size: 19px;

  display: inline-block;

  position: relative;

  padding-bottom: $global-padding;

  text-transform: uppercase;
  font-weight: 800;

  transition: all $duration-normal $easeing-OutExpo;

  &:after {
    content: "";

    position: absolute;

    bottom: 0;
    left: 0;

    height: 7px;
    width: 0;
    background-color: transparent;

    transition: all $duration-normal $easeing-OutExpo;
  }

  + .main-item {
    margin-left: 25px;
  }

  &.router-link-active {
    color: $color-red;

    &:after {
      background-color: $color-red;
      width: 100%;
    }
  }

  &:hover:not(.router-link-active) {
    color: $color-red;
    transition: all $duration-normal $easeing-OutExpo;

    &:after {
      background-color: $color-grey;
      width: 100%;
    }
  }
}

// Sub navigation & service
.sub-navigation {
  display: flex;
  margin-bottom: auto;
}

.sub {
  flex: 1 1 50%;

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  margin: 0 -5px 0 0;

  .sub-item:first-child {
    padding-left: 0;
  }
}

.sub-item {
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 700;
  color: #567697;

  padding: 5px 11px;

  cursor: pointer;

  letter-spacing: 3%;

  &.selected {
    color: #aabacb;
  }

  &:hover:not(.selected) {
    color: #0B2B62;
  }
}

.service {
  display: inline-flex;
  flex: 1 1 1%;
  margin-left: auto;

  justify-content: flex-end;

  .sub-item:last-child {
    padding-right: 0;
  }

  @media (max-width: 835px) {
    position: absolute;
    right: 0;
    top: 25px;

    background-color: $color-white;
    background: linear-gradient(#FDFDFD, #FBFBFB);

    border-left: 1px solid $color-grey;
  }
}

.seperator {
  height: 100%;
  width: 1px;

  background: $color-grey;

  @media #{$below-breakpoint-768} {
    display: none;
  }
}

.mobile-navigation {
  position: absolute;
  top: 70px;
  left: 0;
  width: 100vw;

  z-index: 100;

  background: $color-white;

  box-shadow: 0 2px 4px 0 rgba($color-black, .1);

  display: flex;
  flex-wrap: wrap;

  padding: 35px $global-padding $global-padding;

  transform: translateX(-100%);
  opacity: 0;

  @at-root .main-navigtaion-shown #{&} {
    @media #{$below-breakpoint-768} {
      transform: translateX(0);
      opacity: 1;
    }
  }

  div {
    flex: 0 0 50%;

    display: flex;
    flex-direction: column;

    margin-bottom: 30px;
  }

  small {
    color: #aabacb;
    font-weight: 700;
    text-transform: uppercase;
    font-size: 13px;

    display: block;
    margin-bottom: 15px;
  }

  a, a:visited {
    font-size: 14px;
    letter-spacing: -2%;
    font-weight: 700;

    text-transform: uppercase;

    margin-bottom: 15px;

    color: $color-black-x;

    &:hover {
      color: #567697;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/partials/top.vue